import React from 'react';
import { motion } from 'framer-motion';
import { MASCOT } from '../data/media';
type MascotTone = 'light' | 'gold' | 'dark';
interface MascotProps {
  size?: number;
  tone?: MascotTone;
  animate?: boolean;
  className?: string;
}
const toneClasses: Record<MascotTone, string> = {
  light: 'bg-white ring-1 ring-black/10',
  gold: 'bg-gold-500 ring-2 ring-ink/10',
  dark: 'bg-white ring-2 ring-brand-500'
};

/**
 * The brand chicken. Always sits in a light chip so it reads cleanly on
 * black, orange or white surfaces without a cut-out background.
 */
export function Mascot({
  size = 48,
  tone = 'light',
  animate = false,
  className = ''
}: MascotProps) {
  const image = <img src={MASCOT} alt="" aria-hidden="true" className="h-full w-full object-cover scale-[1.08]" loading="lazy" data-id="element-194" data-mp="3ng7f9mewh11a" />;
  if (!animate) {
    return <span className={`inline-flex shrink-0 overflow-hidden rounded-full ${toneClasses[tone]} ${className}`} style={{
      width: size,
      height: size
    }} data-id="element-195" data-mp="1gny96rjytl3i">
        {image}
      </span>;
  }
  return <motion.span className={`inline-flex shrink-0 overflow-hidden rounded-full ${toneClasses[tone]} ${className}`} style={{
    width: size,
    height: size
  }} animate={{
    rotate: [0, -4, 0, 3, 0]
  }} transition={{
    duration: 2.4,
    repeat: Infinity,
    repeatDelay: 5,
    ease: 'easeInOut'
  }} data-id="element-196" data-mp="13r6u4r6dlahy">
      {image}
    </motion.span>;
}